'use client'

import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'
import { SupportIcon } from '@repo/ui/SupportIcon'
import { openSupportEmail } from '@repo/utils/emailSupport'

export const AuthScreenFooter = () => {
  return (
    <MUIStack direction="column" gap="16px" sx={{ padding: '60px', pt: 0, width: '100%' }}>
      <MUIStack direction="row" gap="8px" sx={{ width: '100%' }} onClick={openSupportEmail}>
        <SupportIcon sx={{ width: '20px', height: '20px' }} />

        <MUITypography variant="body1" sx={{ m: 0, opacity: 0.75, width: '100%', cursor: 'pointer' }}>
          Support
        </MUITypography>
      </MUIStack>
      <MUITypography variant="body2" sx={{ m: 0, opacity: 0.75, width: '100%' }}>
        &#169; 2024 Pracctice Limited. All rights reserved.
      </MUITypography>
    </MUIStack>
  )
}
